<template>
  <Table>
    <thead>
      <tr>
        <th data-cy="details">Details</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="key in detailKeys"
        :key="key"
        :data-cy="`${key.toLowerCase().replace(/_/g, '-')}`"
      >
        <td>{{ humanizeDatasetName(key) }}</td>
        <td>
          {{ details[key] }}
        </td>
      </tr>
    </tbody>
  </Table>
</template>

<script>
import Table from "@/components/Table.vue";
export default {
  components: {
    Table
  },
  props: {
    details: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    detailKeys() {
      return Object.keys(this.details);
    }
  }
};
</script>

<style lang="scss" scoped>
tbody tr td:first-child {
  width: 25%;
}
</style>
